import React, { useState } from 'react';

const USERS = {
  alex: { password: 'alex123', role: 'user', name: 'Alex Rivera', id: 'FE-0071' },
  admin: { password: '123', role: 'admin', name: 'Maria Chen', id: 'SUP-0042' },
};

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    const user = USERS[username.toLowerCase().trim()];
    if (!user || user.password !== password) {
      setError('Invalid username or password');
      setShake(true);
      setTimeout(() => setShake(false), 500);
      return;
    }

    onLogin({
      username: username.toLowerCase().trim(),
      role: user.role,
      name: user.name,
      id: user.id,
    });
  };

  return (
    <div className="login-page">
      <div className="login-page__bg" />

      <div className={`login-card ${shake ? 'login-card--shake' : ''}`}>
        <div className="login-card__logo">
          <span className="login-card__logo-icon">R</span>
        </div>
        <h1 className="login-card__title">Relay</h1>
        <p className="login-card__subtitle">Service Engineering Platform</p>

        <form onSubmit={handleSubmit} className="login-card__form">
          {error && (
            <div className="login-card__error">{error}</div>
          )}

          <div className="login-card__field">
            <label className="login-card__label" htmlFor="login-username">
              Username
            </label>
            <input
              id="login-username"
              className="login-card__input"
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
            />
          </div>

          <div className="login-card__field">
            <label className="login-card__label" htmlFor="login-password">
              Password
            </label>
            <input
              id="login-password"
              className="login-card__input"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="login-card__submit">
            Sign In
          </button>
        </form>

        <div className="login-card__hint">
          <p><strong>Demo accounts</strong></p>
          <p>Field engineer: <code>alex</code> / <code>alex123</code></p>
          <p>Supervisor: <code>admin</code> / <code>123</code></p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
